export const surveyPDFChartAcquiredTooltips = {
  IHA: "Internal",
  IHAw: "Internal\nWorsening",
  POA: "External",
  PIHAw: "External\nWorsening"
};
